import { render, staticRenderFns } from "./cms-block-iframe.vue?vue&type=template&id=55970db4&scoped=true"
import script from "./cms-block-iframe.vue?vue&type=script&lang=js"
export * from "./cms-block-iframe.vue?vue&type=script&lang=js"
import style0 from "./cms-block-iframe.vue?vue&type=style&index=0&id=55970db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55970db4",
  null
  
)

export default component.exports